function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { createRoot } from 'react-dom/client';
import { v4 as uuidv4 } from 'uuid';
import AlertItem from "./AlertItem";
import { EnumPosition } from "./interface";

//全局Alert距离
var ALERT_SPACE = '8px';
//全局Alert标签
var ALERT_TAGNAME = 'iron-alert';

// 创建容器
var getContainer = function getContainer(tagName, key) {
  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EnumPosition.top;
  var el = document.createElement(tagName);
  document.body.append(el);
  //TODO 自定义Alert 容器的样式， 可修改
  el.style.position = 'fixed';

  //alert位置（目前支持顶部和底部）
  if (position === EnumPosition.top) {
    el.style.top = ALERT_SPACE;
  } else if (position === EnumPosition.bottom) {
    el.style.bottom = ALERT_SPACE;
  }
  el.style.zIndex = '9999'; //确保层级最高
  el.style.left = '50%';
  el.style.transform = 'translateX(-50%)';
  el.id = key;
  return el;
};

/**
 * 显示通知
 * @param {React.ReactNode} content 通知内容
 */
function Alert(content) {
  var _content$period;
  var key = uuidv4();
  var root = createRoot(getContainer(ALERT_TAGNAME, key, content.position));
  root.render( /*#__PURE__*/React.createElement(AlertItem, _extends({
    period: (_content$period = content.period) !== null && _content$period !== void 0 ? _content$period : 3 //默认3秒关闭
  }, content, {
    onRemove: function onRemove() {
      root.unmount();
      //移除alert
      var ele = document.getElementById(key);
      if (ele) {
        var parEle = ele.parentElement;
        if (parEle) {
          parEle.removeChild(ele);
        }
      }
    }
  })));
}
export default Alert;